"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _editorialNews = _interopRequireDefault(require("./editorial-news.css"));
var overlayColorStyles = ['darkGradient', 'lightGradient'];
var MAX_CHARACTERS_ALLOWED = {
  categoryName: 25,
  sectionHeading: 50,
  paragraph: 160
};
var truncateString = function truncateString(str, num) {
  if (str && str.length > num) {
    return str.slice(0, num).trim() + '...';
  } else {
    return str;
  }
};
var Card = function Card(props) {
  var _clsx;
  var data = props.data,
    language = props.language;
  var colorStyle = data.colorStyle,
    hideArticleDescription = data.hideArticleDescription,
    articleInformation = data.articleInformation,
    imageAlignment = data.imageAlignment;
  var categoryName = articleInformation.categoryName,
    date = articleInformation.date,
    sectionHeading = articleInformation.sectionHeading,
    paragraph = articleInformation.paragraph,
    link = articleInformation.link,
    image = articleInformation.image,
    readTime = articleInformation.readTime;
  var isOverlayCard = overlayColorStyles.includes(colorStyle);
  var shouldFormatDate = function shouldFormatDate(timestamp, region) {
    var date = new Date(parseInt(timestamp));
    if (region === ' ' || date && date.toString() === 'Invalid Date') {
      return ' ';
    }
    var day = date.toLocaleString(region, {
      day: '2-digit'
    }); // DD
    var month = date.toLocaleString(region, {
      month: 'short'
    }); // MMM
    var year = date.toLocaleString(region, {
      year: 'numeric'
    }); // YYYY
    var fullDate = day + " " + month + " " + year;
    return fullDate;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(_editorialNews["default"].card, _editorialNews["default"][colorStyle], _editorialNews["default"][imageAlignment], (_clsx = {}, _clsx[_editorialNews["default"].hideArticleDescription] = hideArticleDescription, _clsx[_editorialNews["default"].isOverlayCard] = isOverlayCard, _clsx))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _editorialNews["default"].inlineImgWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _editorialNews["default"].inlineImg,
    style: {
      backgroundImage: "url(\"" + (image == null ? void 0 : image.image) + "\")"
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _editorialNews["default"].textContentWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _editorialNews["default"].textContent
  }, /*#__PURE__*/_react["default"].createElement("span", {
    "class": _editorialNews["default"].tagCategory
  }, truncateString(categoryName, MAX_CHARACTERS_ALLOWED.categoryName)), /*#__PURE__*/_react["default"].createElement("h3", {
    className: _editorialNews["default"].cardHeading
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: link == null ? void 0 : link.url,
    className: _editorialNews["default"].cardHeadingLink
  }, truncateString(sectionHeading, MAX_CHARACTERS_ALLOWED.sectionHeading))), /*#__PURE__*/_react["default"].createElement("p", {
    className: _editorialNews["default"].bodyCopy
  }, truncateString(paragraph, MAX_CHARACTERS_ALLOWED.paragraph)), /*#__PURE__*/_react["default"].createElement("p", {
    className: _editorialNews["default"].cardDate
  }, date && shouldFormatDate(date, language), date && ' ', readTime && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: _editorialNews["default"].seperator
  }), " ", readTime)))));
};
var _default = Card;
exports["default"] = _default;